import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Meta, Title  } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faCheckCircle, faPhone } from '@fortawesome/free-solid-svg-icons';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AnalyticsService } from '../../analytics/analytics.service';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
 
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: [
        './main.component.scss',
    ],
    standalone: false
})
export class MainComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private meta: Meta,
    private router: Router,
    private reCaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: Object,
    private title: Title,
    private analyticsService: AnalyticsService
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Marco Rubber & Plastics - Homepage", "data-type": "string"});
    this.title.setTitle(`Marco Rubber & Plastics - Sealing Products & Solutions`);
    this.siteKey = environment.capchaSiteKey;
  }

  faCheckCircle = faCheckCircle;
  faPhone = faPhone;
  siteKey;

  inquiryQuoteForm = new FormGroup({
    form_name: new FormControl('Homepage Request'),
    q774: new FormControl(''),
    q775: new FormControl(''),
    fullname: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    deliver: new FormControl('sales@marcorubber.com',Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    company: new FormControl('',[Validators.required]),
    recaptcha: new FormControl('', [Validators.required]),
    message: new FormControl('')
  });

  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  onSubmit() {
    this.reCaptchaV3Service.execute(this.siteKey, 'rfc', (token) => {
      // set the v3 captcha token in the payload
      this.inquiryQuoteForm.patchValue({ recaptcha: token });
      
      // track this form submission event in GTM
      this.analyticsService.track({
        'event' : 'RequestAQuote',
        'eventCategory' : 'FormFill',
        'eventAction' : 'Submit'
      });

      this.markFormGroupTouched(this.inquiryQuoteForm);

      if (!this.inquiryQuoteForm.valid) {
        return;
      }

      const fd: FormData = new FormData();

      // This rudimentary spam trap checks for spambots which eagerly populate 
      //  all fields in a given form, even if hidden.  If either of these secret
      //  hidden fields are populated then we mark this as spam.
      const spamInfo = { isSpam: !!this.q774.value || !!this.q775.value };
      const formWithSpamCalc = { ...this.inquiryQuoteForm.value, ...spamInfo}

      let httpHeaders = new HttpHeaders({
        'Content-Type' : 'multipart/form-data;'
      }); 

      let options = {
        headers: httpHeaders
      };

      fd.append('inquiryFormData', new Blob([JSON.stringify(formWithSpamCalc)], { type: 'application/json' }));
      this.http.post(`${environment.API_URL}/inquiry-quote`, fd, options).subscribe((result) => {
        console.log(result);
        this.analyticsService.trackEvent('Submitted RFQ Form', 'inquiry-quote.htm', null, null);


        let fullName = this.inquiryQuoteForm.value['fullname'];
        const fullNameArr = fullName.split(" ");
        let firstName = fullNameArr[0],
            lastName = fullNameArr[fullNameArr.length-1];

        let userDetails = {
          customer:{
            first_name:firstName,
            last_name:lastName,
            company_name:this.inquiryQuoteForm.value['company'],
            phone:this.inquiryQuoteForm.value['phone'],
            email:this.inquiryQuoteForm.value['email']
          }
        }

        this.router.navigate(['/form-confirmation-home'], {state:{data:userDetails}});
      });
    }, {
      useGlobalDomain: false // optional
    });
  }


  ngOnInit() {
  }

   // template conveniene accessors
   get form_name() { return this.inquiryQuoteForm.get('form_name'); }
   get q774() { return this.inquiryQuoteForm.get('q774'); }
   get q775() { return this.inquiryQuoteForm.get('q775'); }
   get fullname() { return this.inquiryQuoteForm.get('fullname'); }
   get phone() { return this.inquiryQuoteForm.get('phone'); }
   get email() { return this.inquiryQuoteForm.get('email'); }
   get company() { return this.inquiryQuoteForm.get('company'); }
   get message() { return this.inquiryQuoteForm.get('message'); }
  

}
